import React from "react"
import { SimpleForm, 
    ReferenceInput,
    email,
    SaveButton, 
    DeleteButton, 
    required,
    useRecordContext } from "react-admin"
import { ScreenEmpty } from "components/ui/screen"
import { useTranslate } from "ra-core"
import { Grid } from "@mui/material"
import { TextInputWithAudit, AutocompleteInputWithAudit, SelectInputWithAudit } from "components/audit/audit.inputs"

interface props {
    readonly: boolean
    newRecord: boolean
}
const TableName = "companies"

function Form(props: React.PropsWithChildren<props>): JSX.Element  {
    const { readonly, newRecord } = props
    const translate = useTranslate()
    const record = useRecordContext()
    console.log(record)
    return (
        <SimpleForm toolbar={false}>
            <Grid container columnSpacing="8">
                <Grid item xs={4}>
                    <TextInputWithAudit source="name" disabled={readonly} validate={[required()]} label={translate("resources.companies.fields.name")} tableName={TableName} showAuditIcon={readonly}/>
                </Grid>
                <Grid item xs={4}>
                    <TextInputWithAudit source="short_name" disabled={readonly} validate={[required()]} label={translate("resources.companies.fields.short_name")} tableName={TableName} showAuditIcon={readonly}/>
                </Grid>
            </Grid>
            <Grid container columnSpacing="8">
                <Grid item xs={4}>
                    <TextInputWithAudit source="email" disabled={readonly} validate={[required(), email()]} label={translate("resources.companies.fields.email")} tableName={TableName} showAuditIcon={readonly}/>
                </Grid>
                <Grid item xs={4}>
                    <ReferenceInput label={translate("resources.companies.fields.type_id")} source="type_id" reference="company-types">
                        <SelectInputWithAudit optionText="name" disabled={readonly} validate={[required()]} tableName={TableName} showAuditIcon={readonly} />
                    </ReferenceInput>
                </Grid>
            </Grid>
            <Grid container columnSpacing="8">
                <Grid item xs={6}>
                    <ReferenceInput 
                        label={translate("resources.companies.fields.parent_id")} 
                        source="parent_id" 
                        reference="companies"
                        queryOptions={{
                            select: (res: any) => (
                                res?.data
                                    ? { ...res, data: res.data.filter((o: any) => String(o?.id) !== String((record as any)?.id)) }
                                    : res
                            ),
                        }}
                    >
                        <AutocompleteInputWithAudit 
                            optionText="name"
                            optionValue="id"
                            disabled={readonly}
                            tableName={TableName} 
                            showAuditIcon={readonly}
                        />
                    </ReferenceInput>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={6}>
                    <TextInputWithAudit source="description" disabled={readonly} multiline rows={5} label={translate("resources.common.fields.description")} tableName={TableName} showAuditIcon={readonly}/>
                </Grid>
            </Grid>
            <ScreenEmpty enabled={!readonly}>
                <Grid container>
                    <Grid item xs={6}>
                        <SaveButton />
                    </Grid>
                    <ScreenEmpty enabled={!newRecord}>
                        <Grid item xs={6}>
                            <DeleteButton />
                        </Grid>
                    </ScreenEmpty>
                </Grid>
            </ScreenEmpty>
        </SimpleForm>
    )
}

Form.defaultProps = {
    readonly: false,
    newRecord: false,
}

export default Form